import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAuthority } from 'types/authority.types';
import {
  TCurrentUser,
  TGetUserRequestPayload,
  TSearchParams,
  TUserPreview,
  TUsersState,
} from '../../types/users';
import { Provider } from './../../types/provider.types';

const initialState: TUsersState = {
  currentUser: null,
  business: [],
  searchHistory: [],
  permissions: [],
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    getCurrentUserRequest: (_, __: PayloadAction<TGetUserRequestPayload | undefined>) => {},
    getCurrentUserSuccess: (state, action: PayloadAction<TCurrentUser>) => {
      state.currentUser = action.payload;
    },
    postSearchRequest: (_, __: PayloadAction<TSearchParams>) => {},
    postSearchSuccess: (state, action: PayloadAction<TUserPreview[]>) => {
      const ids = new Set(state.searchHistory.map((h) => h.id));
      const merged = [...state.searchHistory, ...action.payload.filter((h) => !ids.has(h.id))];
      return {
        ...state,
        searchHistory: merged,
      };
    },
    setProviderId: (state, action: PayloadAction<string>) => {
      state.business = [{ id: action.payload }];
    },
    setCurrentProvider: (state, action: PayloadAction<Provider>) => {
      state.currentProvider = action.payload;
    },
    setCurrentPermissions: (state, action: PayloadAction<TAuthority[]>) => {
      state.permissions = action.payload;
    },
  },
});

export const { actions, name, reducer } = usersSlice;
export default usersSlice.reducer;
